"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmosTransactionStatusManager = void 0;
const errors_1 = require("@ledgerhq/errors");
const errors_2 = require("../../errors");
const bignumber_js_1 = require("bignumber.js");
const logic_1 = require("./logic");
const invariant_1 = __importDefault(require("invariant"));
const bech32 = __importStar(require("bech32"));
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const chain_1 = __importDefault(require("./chain/chain"));
class CosmosTransactionStatusManager {
    constructor() {
        this.getTransactionStatus = (a, t) => __awaiter(this, void 0, void 0, function* () {
            if (t.mode === "send") {
                // We isolate the send transaction that it's a little bit different from the rest
                return yield this.getSendTransactionStatus(a, t);
            }
            else if (t.mode === "delegate") {
                return yield this.getDelegateTransactionStatus(a, t);
            }
            const errors = {};
            const warnings = {};
            // here we only treat about all other mode than delegate and send
            if (t.validators.some(v => !v.address || !v.address.includes((0, chain_1.default)(a.currency.id).validatorPrefix)) ||
                t.validators.length === 0)
                errors.recipient = new errors_1.InvalidAddress(undefined, {
                    currencyName: a.currency.name,
                });
            if (t.mode === "redelegate") {
                const redelegationError = this.redelegationStatusError(a, t);
                if (redelegationError) {
                    // Note : note sure if I have to put this error on this field
                    errors.redelegation = redelegationError;
                }
            }
            else if (t.mode === "undelegate") {
                (0, invariant_1.default)(a.cosmosResources && a.cosmosResources.unbondings.length < logic_1.COSMOS_MAX_UNBONDINGS, "unbondings should not have more than 6 entries");
                if (t.validators.length === 0)
                    errors.recipient = new errors_1.InvalidAddress(undefined, {
                        currencyName: a.currency.name,
                    });
                const [first] = t.validators;
                const unbondingError = first && this.isDelegable(a, first.address, first.amount);
                if (unbondingError) {
                    errors.unbonding = unbondingError;
                }
            }
            const validatorAmount = t.validators.reduce((old, current) => old.plus(current.amount), new bignumber_js_1.BigNumber(0));
            if (t.mode !== "claimReward" && validatorAmount.lte(0)) {
                errors.amount = new errors_1.AmountRequired();
            }
            const estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
            if (!t.fees) {
                errors.fees = new errors_1.FeeNotLoaded();
            }
            let totalSpent = estimatedFees;
            if (["claimReward", "claimRewardCompound"].includes(t.mode)) {
                const { cosmosResources } = a;
                (0, invariant_1.default)(cosmosResources, "cosmosResources should exist");
                const claimReward = t.validators.length && cosmosResources
                    ? cosmosResources.delegations.find(delegation => delegation.validatorAddress === t.validators[0].address)
                    : null;
                if (claimReward && estimatedFees.gt(claimReward.pendingRewards)) {
                    warnings.claimReward = new errors_2.ClaimRewardsFeesWarning();
                }
            }
            if (!errors.recipient &&
                !errors.amount &&
                (validatorAmount.lt(0) || totalSpent.gt(a.spendableBalance))) {
                errors.amount = new errors_1.NotEnoughBalance();
                totalSpent = new bignumber_js_1.BigNumber(0);
            }
            return Promise.resolve({
                errors,
                warnings,
                estimatedFees,
                amount: new bignumber_js_1.BigNumber(0),
                totalSpent,
            });
        });
        this.getDelegateTransactionStatus = (a, t) => __awaiter(this, void 0, void 0, function* () {
            const errors = {};
            const warnings = {};
            if (t.validators.some(v => !v.address || !v.address.includes((0, chain_1.default)(a.currency.id).validatorPrefix)) ||
                t.validators.length === 0)
                errors.recipient = new errors_1.InvalidAddress(undefined, {
                    currencyName: a.currency.name,
                });
            if (t.validators.length > logic_1.COSMOS_MAX_DELEGATIONS) {
                errors.validators = new errors_2.CosmosTooManyValidators();
            }
            const estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
            if (!t.fees || !t.fees.gt(0)) {
                errors.fees = new errors_1.FeeNotLoaded();
            }
            const amount = t.useAllAmount ? (0, logic_1.getMaxEstimatedBalance)(a, estimatedFees) : t.amount;
            const totalSpent = amount.plus(estimatedFees);
            if (amount.eq(0)) {
                errors.amount = new errors_1.AmountRequired();
            }
            if (!errors.recipient &&
                !errors.amount &&
                (amount.lt(0) || totalSpent.gt(a.spendableBalance))) {
                errors.amount = new errors_1.NotEnoughBalance();
            }
            if (!errors.amount && t.useAllAmount) {
                warnings.amount = new errors_2.CosmosDelegateAllFundsWarning();
            }
            return Promise.resolve({
                errors,
                warnings,
                estimatedFees,
                amount,
                totalSpent,
            });
        });
        this.getSendTransactionStatus = (a, t) => __awaiter(this, void 0, void 0, function* () {
            const errors = {};
            const warnings = {};
            if (!t.recipient) {
                errors.recipient = new errors_1.RecipientRequired("");
            }
            else if (a.freshAddress === t.recipient) {
                errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
            }
            else {
                let isValid = true;
                try {
                    bech32.decode(t.recipient);
                }
                catch (e) {
                    isValid = false;
                }
                const currency = (0, cryptoassets_1.findCryptoCurrencyById)(a.currency.name.toLowerCase());
                let prefix = "";
                if (currency) {
                    prefix = (0, chain_1.default)(currency.id).prefix;
                }
                isValid = isValid && t.recipient.startsWith(prefix);
                if (!isValid) {
                    errors.recipient = new errors_1.InvalidAddress(undefined, {
                        currencyName: a.currency.name,
                    });
                }
            }
            let amount = t.amount;
            if (amount.lte(0) && !t.useAllAmount) {
                errors.amount = new errors_1.AmountRequired();
            }
            const estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
            if (!t.fees || !t.fees.gt(0)) {
                errors.fees = new errors_1.FeeNotLoaded();
            }
            amount = t.useAllAmount ? (0, logic_1.getMaxEstimatedBalance)(a, estimatedFees) : amount;
            const totalSpent = amount.plus(estimatedFees);
            if ((amount.lte(0) && t.useAllAmount) || // if use all Amount sets an amount at 0
                (!errors.recipient && !errors.amount && totalSpent.gt(a.spendableBalance)) // if spendable balance lower than total
            ) {
                errors.amount = new errors_1.NotEnoughBalance();
            }
            if (a.cosmosResources && a.cosmosResources.delegations.length > 0 && t.useAllAmount) {
                warnings.amount = new errors_1.RecommendUndelegation();
            }
            return Promise.resolve({
                errors,
                warnings,
                estimatedFees,
                amount,
                totalSpent,
            });
        });
        this.redelegationStatusError = (a, t) => {
            if (a.cosmosResources) {
                const redelegations = a.cosmosResources.redelegations;
                (0, invariant_1.default)(redelegations.length < logic_1.COSMOS_MAX_REDELEGATIONS, "redelegation should not have more than 6 entries");
                if (redelegations.some(redelegation => {
                    const dstValidator = redelegation.validatorDstAddress;
                    return dstValidator === t.sourceValidator && redelegation.completionDate > new Date();
                })) {
                    return new errors_2.CosmosRedelegationInProgress();
                }
                if (t.validators.length > 0) {
                    if (t.sourceValidator === t.validators[0].address) {
                        return new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                    }
                    else {
                        return this.isDelegable(a, t.sourceValidator, t.validators[0].amount);
                    }
                }
            }
            return null;
        };
        this.isDelegable = (a, address, amount) => {
            const { cosmosResources } = a;
            (0, invariant_1.default)(cosmosResources, "cosmosResources should exist");
            if (cosmosResources &&
                cosmosResources.delegations.some(delegation => delegation.validatorAddress === address && delegation.amount.lt(amount))) {
                return new errors_2.NotEnoughDelegationBalance();
            }
            return null;
        };
    }
}
exports.CosmosTransactionStatusManager = CosmosTransactionStatusManager;
const cosmosTransactionStatusManager = new CosmosTransactionStatusManager();
exports.default = cosmosTransactionStatusManager.getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map